'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);
var _lodash = require('lodash');

var _components = require('../../components');
var _containers = require('../../containers');
var _PropertiesMultiSelectWrapper = require('../../containers/PropertiesMultiSelectWrapper/PropertiesMultiSelectWrapper');var _PropertiesMultiSelectWrapper2 = _interopRequireDefault(_PropertiesMultiSelectWrapper);
var _AgentsDropdownContainer = require('../../containers/AgentsDropdownContainer/AgentsDropdownContainer');var _AgentsDropdownContainer2 = _interopRequireDefault(_AgentsDropdownContainer);

var _constants = require('../../constants');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _formatPropertyTypes = require('../../utils/formatPropertyTypes');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _formatSearchBoxData = require('../../utils/formatSearchBoxData');
var _getManagePropertiesRowsPerPage = require('../../utils/getManagePropertiesRowsPerPage');var _getManagePropertiesRowsPerPage2 = _interopRequireDefault(_getManagePropertiesRowsPerPage);

var _ManagePropertiesFilters = require('./ManagePropertiesFilters.scss');var _ManagePropertiesFilters2 = _interopRequireDefault(_ManagePropertiesFilters);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var ManagePropertiesFilters = function (_Component) {_inherits(ManagePropertiesFilters, _Component);function ManagePropertiesFilters(props) {_classCallCheck(this, ManagePropertiesFilters);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.
































    handleChangeMultiSelect = function (value) {
      var fields = _constants.columnsDefaultState.filter(function (field) {return value.includes(field.name);});
      return _this.props.updateSelectedColumns(fields);
    };_this.

    formatPriceParameters = function (field) {return {
        value: (0, _beautifyNumber2.default)(_this.state.price[field]),
        onChange: function onChange(value) {var _Object$assign;return (
            _this.changeFilters('price', Object.assign({},
            _this.state.price, (_Object$assign = {}, _Object$assign[
            field] = (0, _clearNumber2.default)(value), _Object$assign))));} };};_this.



    formatAgentsParams = function (agents) {return agents.reduce(function (acc, curr) {
        if (curr.startsWith('s-')) {
          var staffId = curr.slice(2);
          acc.staff_ids.push(staffId);
          return acc;
        }
        acc.phone_numbers.push((0, _formatPhoneNumber.addPhoneCode)(curr));
        return acc;
      }, { staff_ids: [], phone_numbers: [] });};_this.

    formatSearchParams = function (data) {
      var searchArray = Object.keys(data).filter(function (elem) {return (
          data[elem] instanceof Array && (data[elem].length > 1 || data[elem][0] !== 'all') ||
          typeof data[elem] === 'string' && data[elem] !== 'all');});

      var array = Object.keys((0, _pick2.default)(data, searchArray));
      var searchObject = {
        $limit: (0, _getManagePropertiesRowsPerPage2.default)(),
        $skip: 0 };


      array.forEach(function (elem) {
        if (elem === 'rooms') {
          searchObject['additional_info.rooms'] = [].concat(data[elem], data[elem].map(function (el) {return el + '.5';}));
        } else {
          searchObject[elem] = data[elem];
        }
      });

      if (data.is_active !== 'all') {
        searchObject.is_active = data.is_active;
      }

      if (data.agents !== undefined && !data.agents.includes('all')) {var _this$formatAgentsPar =
        _this.formatAgentsParams(data.agents),phone_numbers = _this$formatAgentsPar.phone_numbers,staff_ids = _this$formatAgentsPar.staff_ids;

        searchObject.phone_number = phone_numbers;
        searchObject.staff_id = staff_ids;
      }

      if (data.price) {var _data$price =
        data.price,minPrice = _data$price.minPrice,maxPrice = _data$price.maxPrice;
        if (!!minPrice || !!maxPrice) {
          searchObject.price = '[' + minPrice + (maxPrice ? ',' + maxPrice : '') + ']';
        }
      }

      searchObject.search = data.search || undefined;
      searchObject.search_field = data.search ? data.search_field : undefined;
      searchObject.language = _this.props.locale;
      searchObject.agents = undefined;

      return searchObject;
    };_this.

    handleGetAgentSelectOptions = function () {var _this$props =
      _this.props,_this$props$staff = _this$props.staff,staff = _this$props$staff === undefined ? [] : _this$props$staff,_this$props$virtualNu = _this$props.virtualNumbers,virtualNumbers = _this$props$virtualNu === undefined ? [] : _this$props$virtualNu,translate = _this$props.translate;

      var allOption = { label: translate('managePage', 'allAgents'), value: 'all' };

      var staffOptions = staff.map(function (user) {return {
          label: user.label,
          value: 's-' + user.value };});


      var virtualOptions = (0, _formatSearchBoxData.formatAgentSelectOptions)(virtualNumbers, translate);

      return [
      allOption].concat(
      staffOptions,
      virtualOptions);

    };_this.

    changeFilters = function (field, value) {var _Object$assign2;var _this$props2 =
      _this.props,token = _this$props2.token,sortOrder = _this$props2.sortOrder;
      var data = Object.assign({},
      _this.state, (_Object$assign2 = {}, _Object$assign2[
      field] = value, _Object$assign2));

      _this.setState(Object.assign({}, data));
      _this.props.setCurrentPaginationStep(1);
      _this.props.loadUserProperties(Object.assign({
        token: token,
        data: _this.formatSearchParams(data),
        sort_by: _this.props.currentSorting },
      sortOrder ? { sort_order: sortOrder } : {}));

    };_this.
    filterPropertyTypes = function () {
      if (_this.state.search_option === 'all') {
        return _this.props.propertyTypes.map(function (item) {return item.name;});
      }

      return (0, _formatPropertyTypes.unitePropertyTypesBySections)(_this.props.sortedPropertyTypes, _this.state.search_option);
    };_this.

    handleChangeSearchInput = function (e) {
      _this.setState({ search: e.target.value });
      _this.debouncedFiltersChange('search', e.target.value);
    };_this.

    handleChangeSearchField = function (_ref) {var value = _ref.value;
      _this.setState({ search_field: value });
      _this.debouncedFiltersChange('search_field', value);
    };_this.

    handleChangeAgents = function (value) {
      _this.changeFilters('agents', value);
    };_this.state = { property_origin: 'all', search_option: 'all', property_type: ['all'], rooms: ['all'], is_active: true, price: { minPrice: '', maxPrice: '' }, search: '', search_field: 'address', // Staff and employees select
      agents: ['all'] };_this.debouncedFiltersChange = (0, _lodash.debounce)(_this.changeFilters, 300);return _this;}ManagePropertiesFilters.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var token = nextProps.token,currentSorting = nextProps.currentSorting,sortOrder = nextProps.sortOrder,locale = nextProps.locale;if (currentSorting !== this.props.currentSorting || sortOrder !== this.props.sortOrder) {var data = Object.assign({}, this.state);this.props.loadUserProperties(Object.assign({ token: token, data: this.formatSearchParams(data), sort_by: currentSorting }, sortOrder ? { sort_order: sortOrder } : {}));}};ManagePropertiesFilters.prototype.
  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,locale = _props.locale,userData = _props.userData;

    var isForeign = (0, _lodash.get)(this.props, 'userData.publish_permissions.foreign', false);

    var opTypesValues = _constants.optionTypesValuesWithAll.map(function (_ref2) {var title = _ref2.title,value = _ref2.value;return {
        label: translate('search_box', 'searchContainer', title).toString(),
        selected: false,
        value: value };});


    var propertyLocationValues = _constants.optionTypesPropertyLocation.map(function (_ref3) {var title = _ref3.title,value = _ref3.value;return {
        label: translate('search_box', 'searchContainer', title).toString(),
        selected: false,
        value: value };});


    return (
      _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.filtersBlock },
        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.select },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'dealType')),
          _react2.default.createElement(_components.OMOptionTypeDropdown, {
            value: this.state.search_option,
            handleChange: function handleChange(value) {return _this2.changeFilters('search_option', value);},
            options: opTypesValues,
            className: 'manageFilterDropdown' })),


        isForeign &&
        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.select },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'propertyLocation')),
          _react2.default.createElement(_components.OMOptionTypeDropdown, {
            value: this.state.property_origin,
            handleChange: function handleChange(value) {return _this2.changeFilters('property_origin', value);},
            options: propertyLocationValues,
            className: 'manageFilterDropdown' })),



        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.select },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'propertyType')),
          _react2.default.createElement(_containers.PropertyTypesDropdownContainer, {
            locale: locale,
            propertyTypesValues: this.state.property_type,
            propertyTypes: this.filterPropertyTypes(),
            translate: translate,
            handleChange: function handleChange(value) {return _this2.changeFilters('property_type', value);},
            className: 'inManageFilters',
            optionType: this.state.search_option })),


        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.select },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'rooms')),
          _react2.default.createElement(_containers.RoomsDropdownContainer, {
            rooms: this.state.rooms,
            translate: translate('search_box'),
            handleChange: function handleChange(value) {return _this2.changeFilters('rooms', value);},
            className: 'inManageFilters' })),


        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.priceBlock },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'price')),
          _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.price },
            _react2.default.createElement(_components.MinMaxPrices, {
              translate: this.props.translate('search_box', 'searchContainer'),
              minPrice: this.formatPriceParameters('minPrice'),
              maxPrice: this.formatPriceParameters('maxPrice'),
              className: 'managePrice',
              inFilters: true }),

            _react2.default.createElement('span', null, '\u20AA'))),


        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.select },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'status')),
          _react2.default.createElement(_components.OMOptionTypeDropdown, {
            value: this.state.is_active,
            handleChange: function handleChange(value) {return _this2.changeFilters('is_active', value);},
            options: (0, _constants.optionsActivity)(translate),
            className: 'manageFilterDropdown' })),


        this.props.virtualNumbers && !(0, _lodash.get)(this.props.userData, 'assigned_to_agency_id') ?
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_ManagePropertiesFilters2.default.select, _ManagePropertiesFilters2.default.virtualNumber) },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'agents')),
          _react2.default.createElement(_AgentsDropdownContainer2.default, {
            value: this.state.agents,
            onChange: this.handleChangeAgents,
            options: this.handleGetAgentSelectOptions(),
            translate: translate,
            className: 'inManageFilters' })) :

        null,
        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.search },
          _react2.default.createElement('span', { className: _ManagePropertiesFilters2.default.title }, translate('managePage', 'searchPropertyLabel')),
          _react2.default.createElement(_components.SearchByFieldInput, {
            searchField: this.state.search_field,
            onChangeSearchField: this.handleChangeSearchField,
            options: (0, _constants.getSearchPropertyOptions)(translate('managePage')),
            inputClassName: _ManagePropertiesFilters2.default.searchInput,
            selectClassName: _ManagePropertiesFilters2.default.searchSelect,
            value: this.state.search,
            placeholder: translate('managePage', 'searchPropertyPlaceholder'),
            onChange: this.handleChangeSearchInput })),


        !this.props.isMobile &&
        _react2.default.createElement('div', { className: _ManagePropertiesFilters2.default.columnsMultiselect },
          _react2.default.createElement(_PropertiesMultiSelectWrapper2.default, {
            className: _ManagePropertiesFilters2.default.multiSelects,
            options: (0, _constants.columnOptions)(translate),
            title: translate('managePage', 'columnsSetUp')(),
            counterSelected: this.props.selectedColumns.length,
            counterGeneral: _constants.columnsDefaultState.length,
            onChange: this.handleChangeMultiSelect,
            value: this.props.selectedColumns }))));





  };return ManagePropertiesFilters;}(_react.Component);exports.default = ManagePropertiesFilters;


ManagePropertiesFilters.propTypes = {
  virtualNumbers: _propTypes2.default.array,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  propertyTypes: _propTypes2.default.array,
  sortedPropertyTypes: _propTypes2.default.object,
  locale: _propTypes2.default.string.isRequired,
  loadUserProperties: _propTypes2.default.func,
  setCurrentPaginationStep: _propTypes2.default.func,
  token: _propTypes2.default.string,
  isRtl: _propTypes2.default.string,
  updateSelectedColumns: _propTypes2.default.func,
  selectedColumns: _propTypes2.default.array,
  currentSorting: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  staff: _propTypes2.default.array,
  sortOrder: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ManagePropertiesFilters/ManagePropertiesFilters.js
// module id = 2732
// module chunks = 0